import axios from "./axios-wrapper";

export const getAllTokens = async () => {
    const response = await axios.get("/token/");
    return response.data;
}

export const getTokenNetworkMetadataForToken = async (symbol) => {
    const response = await axios.get(`/token/${symbol}/network-metadata`);
    return response.data;
}


export const getTokenBoxPlotData = async (symbol, dimension, params={}) => {

    const from_timestamp = params.from.unix();
    const to_timestamp = params.to.unix();

    const response = await axios.get(`/token/${symbol}/box-plot`, {
        params: {
            dimension,
            from_timestamp,
            to_timestamp,
        },
    });
    return response.data;
}

export const getDimensionByNetwork = async (symbol, dimension, params={}) => {

        const from_timestamp = params.from.unix();
        const to_timestamp = params.to.unix();

        const granularity = params?.granularity || "day";
    
        const response = await axios.post(`/reporting`, {
            params: {
                dimension,
                from_timestamp,
                to_timestamp,
                granularity,
                groupBy: ["token_symbol", "network"],
                token_symbols: [symbol],
            },
        });
        return response.data;
}